import store from '../store';

import saasRoutes from './module/saas';				//工厂管理
import systemRoutes from './module/system';			//系统管理
import spvRoutes from './module/spv';				//spv管理
import financeRoutes from './module/finance';		//财务管理
import mallRoutes from './module/mall';				//会员管理

export default [{
	path: '/login',
	name: 'login',
	props: route => route.query,
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [
		{
			path: '',
			name: 'home',
			component: () => import('@/pages/home/index')
		}, {
			path: 'saas',
			name: 'p_saas',
			component: {
				render: h => h('router-view')
			},
			children: [
				...saasRoutes
			]
		}, {
			path: 'spv',
			name: 'p_spv',
			component: {
				render: h => h('router-view')
			},
			children: [
				...spvRoutes
			]
		}, {
			path: 'finance',
			name: 'p_finance',
			component: {
				render: h => h('router-view')
			},
			children: [
				...financeRoutes
			]
		}, {
			path: 'mall',
			name: 'p_mall',
			component: {
				render: h => h('router-view')
			},
			children: [
				...mallRoutes
			]
		}, {
			path: 'system',
			name: 'p_system',
			component: {
				render: h => h('router-view')
			},
			children: [
				...systemRoutes
			]
		}, {
			path: '404',
			name: '404',
			component: () => import('@/pages/error/404')
		}
	]
}, {
	path: '/doc',
	component: () => import('@/pages/doc/index')
}, {
	path: '*',
	redirect: '/'
}];